import {
  UsersIcon,
  TargetIcon,
  VideoIcon,
  PackageIcon,
  BoxIcon,
  BriefcaseIcon,
} from 'lucide-react'

export type OutcomeEducation = {
  outcome: string
  icon: any
  headline: string
  description: string
  recommendedFunnelTypes: string[]
  tips: string[]
}

export const OUTCOME_EDUCATION: OutcomeEducation[] = [
  {
    outcome: 'Get more followers',
    icon: UsersIcon,
    headline: 'How to Get More People Following You',
    description:
      'The best way to get followers is to give them something awesome for free — like a helpful guide or checklist. When they give you their email to get it, boom, now you can talk to them whenever you want!',
    recommendedFunnelTypes: ['lead', 'challenge'],
    tips: [
      'Use a "Get Emails" template to collect email addresses with a free guide.',
      'Try a "Run a Challenge" template to get a group of people excited together.',
      'Always give them something helpful first before asking for anything.',
    ],
  },
  {
    outcome: 'Find customers',
    icon: TargetIcon,
    headline: 'How to Find People Who Want to Buy',
    description:
      "Finding customers is all about figuring out who actually wants what you're selling. The trick is to get them to raise their hand first — like filling out a form or booking a call — so you know they're interested.",
    recommendedFunnelTypes: ['lead', 'appointment'],
    tips: [
      'Start with a "Get Emails" template to find interested people.',
      'Use a "Book Calls" template to talk to the serious ones.',
      'Follow up with everyone who signs up — most people need a few reminders!',
    ],
  },
  {
    outcome: 'Do a live video',
    icon: VideoIcon,
    headline: 'How to Sell with a Live Video',
    description:
      "Live videos (webinars) are amazing because people get to see the real you. Teach them something cool for about 20 minutes, then show them how your paid thing can help them even more. It's like a free class that leads to your offer!",
    recommendedFunnelTypes: ['presentation'],
    tips: [
      'Use a "Do a Webinar" template to set up your sign-up and video pages.',
      'Teach something genuinely useful in the first 20 minutes.',
      'Give a special bonus to people who buy before the video ends.',
    ],
  },
  {
    outcome: 'Sell digital stuff',
    icon: PackageIcon,
    headline: 'How to Sell Digital Products',
    description:
      'Digital stuff (like courses, ebooks, or templates) is awesome because you make it once and sell it forever. The key is making it super easy to buy — like, two clicks and done. Then offer them something extra right before they finish paying!',
    recommendedFunnelTypes: ['product', 'presentation'],
    tips: [
      'Use a "Sell Stuff" template with a simple sales page and checkout.',
      'For expensive digital products, try a "Do a Webinar" template first to build trust.',
      'Always add a little extra offer on the checkout page — most people will say yes!',
    ],
  },
  {
    outcome: 'Sell physical stuff',
    icon: BoxIcon,
    headline: 'How to Sell Physical Products Online',
    description:
      "Selling physical stuff online works best when you focus on ONE product at a time instead of showing people a huge catalog. Make a simple page that shows off your product, let them buy it, and then offer them something else they'd love!",
    recommendedFunnelTypes: ['product'],
    tips: [
      'Use a "Sell Stuff" template with great photos and a clear buy button.',
      'Show reviews from happy customers right next to the buy button.',
      'Offer a matching product right after they buy — like socks with shoes!',
    ],
  },
  {
    outcome: 'Sell my services',
    icon: BriefcaseIcon,
    headline: 'How to Get Clients for Your Service',
    description:
      "When you sell a service (like coaching, design, or consulting), people need to trust you first. The best approach is to let them learn about you, then book a call so you can chat and see if you're a good fit for each other.",
    recommendedFunnelTypes: ['appointment', 'lead', 'presentation'],
    tips: [
      'Use a "Book Calls" template so people can schedule a time to talk.',
      'Start with a "Get Emails" template to build trust before asking for a call.',
      'For expensive services, try a "Do a Webinar" template to show your expertise first.',
    ],
  },
]
